<template lang="pug">
#admin_container.container-small
  h1#container_title 설치매장 관리
  .container_wr
    #s41.sub
      .in
        section#bo_v_atc
          .info
            ul
              li
                h3 매장명
                p {{ resData.name }}
              li
                h3 주소
                p {{ resData.addr }}
              li
                h3 전화번호
                p {{ resData.mobile }}
              li.widelist(v-if="resData.memo")
                h3 메모
                p.store-memo {{ resData.memo }}
              li.imglist(v-if="resData.file_fir || resData.file_sec")
                h3 사진
                img.shop_img(:src="resData.file_fir" alt='' v-if="resData.file_fir")
                img.shop_img(:src="resData.file_sec" alt='' v-if="resData.file_sec")
          .bo_v_bot
            .bo_v_com
              li
                a.btn_b01(@click='$_goTo({name: "store-edit-admin", params: {id: args.id}, query: {nation: args.nation}})') 수정
              li
                a.btn_b01(@click='delList()') 삭제
              li
                a(@click='$_goTo({name: "store-admin", query: {nation: args.nation}})').btn_b01.btn_list 목록
              li
                a(@click='$_goTo({name: "store-write-admin"})').btn_b02 매장추가
    
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    
</template>

<script>
export default {
  components: {},
  data() {
    return {
      resData: {},
      args: {
        nation: this.$route.query.nation,
        id: this.$route.params.id,
      },
      res: [],
      checked: [],
      flagData: {
        editFlag: false,
        descList: true,
      },
    };
  },
  computed: {},
  methods: {
    async getData() {
      await this.$_admin_get('admin/store/detail', {
        id: this.args.id,
        nation: this.args.nation,
      }).then(res => {
        this.resData = res.data.res[0];
      });
    },
    async delList() {
      await this.$_axios('PUT', 'admin/store/del', {
        id: this.args.id,
        nation: this.args.nation,
      });
      alert('삭제되었습니다.');
      this.$_goTo({ name: 'store-admin', query: { nation: this.args.nation } });
    },
  },
  mounted() {
    this.getData();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/store.css';
.in #bo_v_atc .info ul li.imglist {
  width: 100%;
}
#bo_v_atc .info ul li p,
#bo_v_atc .info ul li h3 {
  font-size: 18px !important;
}
#s41.sub .in section#bo_v_atc {
  padding: 0;
}
.shop_img {
  width: 30%;
}
#bo_v .info ul li.imglist {
  border-bottom: 1px solid #ddd;
  width: 100%;
}
.bo_v_bot {
  margin-top: 60px;
}
.bo_v_com {
  margin: 20px 0;
  float: right;
}
#bo_v .info ul li.widelist {
  width: 100%;
  display: flex;
  font-size: 18px;
}
.bo_v_com > li {
  position: relative;
  float: left;
  margin-left: 5px;
}
#bo_v a.btn_b01 {
  border: 1px solid #aaa;
  /* background: #666; */
}
#bo_v a.btn_list {
  padding: 10px 25px;
  background: #666;
  border-color: #666;
  color: #fff;
}
a.btn_b02,
.btn_b02 {
  border: 1px solid #aaa;
  background: #333;
  padding: 10px 25px;
}
a.btn_b02:hover,
.btn_b02:hover {
  background: #f7941e;
}
#bo_v_atc {
  min-height: 200px;
  height: auto !important;
  height: 200px;
  padding: 100px 0 50px;
}
.in section#bo_v_atc .bo_v_bot .bo_v_com a.btn_b01 {
  border: 1px solid #aaa;
}
a.btn_b01,
.btn_b01 {
  width: 100%;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
}
a.btn_b02,
.btn_b02 {
  width: 100%;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
}
#bo_v_atc .info ul {
  display: flex;
  flex-wrap: wrap;
}
#bo_v_atc .info ul li {
  display: flex;
  width: 50%;
  font-size: 18px;
}
#bo_v_atc .info ul li:first-child {
  width: 100%;
  border-top: 1px solid #ddd;
}
#bo_v_atc .info ul li h3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  background: #333;
  color: #fff;
  text-align: center;
  border-bottom: 1px solid #666;
  padding: 15px 0;
}
#bo_v_atc .info ul li p {
  display: flex;
  align-items: center;
  width: calc(100% - 130px);
  padding-left: 20px;
  border-bottom: 1px solid #ddd;
  padding: 15px 0 15px 20px;
}
#bo_v_atc .info ul li.widelist {
  width: 100%;
}

@media (max-width: 1024px) {
  #bo_v_atc .info ul li {
    font-size: 16px;
  }
  #bo_v_atc .info ul li h3 {
    width: 110px;
    padding: 10px 0;
  }
  #bo_v_atc .info ul li p {
    width: calc(100% - 110px);
  }
}
@media (max-width: 768px) {
  #bo_v_atc .info ul {
    display: block;
  }
  #bo_v_atc .info ul li {
    width: 100%;
    font-size: 14px;
  }
}
</style>
